import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import './index.css';
import registerServiceWorker from './registerServiceWorker';
import makeMainRoutes from './routes';

const routes = makeMainRoutes();

ReactDOM.render(routes, document.getElementById('root'));
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js